<template>
  <div>
    <input class="p-3 border-2 rounded-md focus:border-gray-500 border-gray-200 outline-none" type="text" :placeholder="placeholder">
  </div>
</template>

<script>
export default {
  props: ['placeholder']
}
</script>

<style>

</style>